module.exports = __webpack_public_path__ + "static/media/living_room_turquoise.d04da3d7.png";